// Bucket count for both daily-activity panels. 30 (one bucket per day over the 30-day
// window) rather than the Chart View's 9 — see .claude/docs/plan-IncidentFeedOverview.md.
// The Threat Feed Chart View keeps 9; these are separate call sites.
//
// ⚠️ `get-customer-events`'s createBuckets computes
//    bucketSize = Math.round((end - start) / (86400000 * numberOfBuckets))
// which is 0 — and therefore returns an EMPTY series — for any window under 15 days at
// 30 buckets. The fixed 30-day window below does not trip it. A shorter window would,
// silently: totalRecords is computed before bucketing, so "Pages scanned: N" still
// renders correctly beside a blank chart and it does not look like a failure.
// Recorded on PIXMC-6520 and QA's PIXMC-6523.
export const INCIDENT_FEED_BUCKET_COUNT = 30

// The Overview window is fixed at 30 days for this release — there is deliberately no
// range picker. Both the donut and the two panels read these, so they cannot describe
// different days. A picker is a later change: it would need these to become slice state
// again, and it must not offer anything under 15 days (see the bucketing note above).
export const INCIDENT_FEED_LOOKBACK_DAYS = 30
export const INCIDENT_FEED_WINDOW_LABEL = `Last ${INCIDENT_FEED_LOOKBACK_DAYS} days`

export const incidentFeedInitialState = {
  // --- Donut: dashboard/stats/{id}/overview/phishing-detections (PIXMC-6520 WS-1) ---
  // `available` is the D-7 state discriminator and starts null (= "not asked yet"), never
  // false — false means the API answered "no rows". Counts stay null until a payload
  // arrives: 0 means "we checked and there is nothing", null means "we do not know".
  overview: {
    available: null,
    pixmVerified: null,
    verifiedPhish: null,
    aiSuspicious: null,
    total: null,
    lookbackDays: null,
    computedAt: null,
  },
  overviewLoading: false,
  overviewError: null,
  // Customer the in-flight request was issued for. A response carrying a different
  // one is stale and is dropped — see the slice.
  overviewRequestedFor: null,

  // --- Phishing detections panel: dashboard/stats/{id}/phishing-detections (WS-2) ---
  // `records` is normalised to the { detectionTime, records } shape the existing charts
  // use, so one TrendPanel serves this and Pages scanned alike (the wire shape is
  // { dtcTime, rcds } — see the field map in the plan).
  phishingDetections: {
    available: null,
    records: [],
    totalRecords: 0,
    lookbackDays: null,
    computedAt: null,
  },
  phishingDetectionsLoading: false,
  phishingDetectionsError: null,
  // Customer the in-flight request was issued for. A response carrying a different
  // one is stale and is dropped — see the slice.
  phishingDetectionsRequestedFor: null,

  // --- Pages scanned panel: dashboard/stats/{id}/events, unchanged contract, 30 buckets ---
  pagesScanned: {
    records: [],
    totalRecords: 0,
  },
  pagesScannedLoading: false,
  pagesScannedError: null,
  // Customer the in-flight request was issued for. A response carrying a different
  // one is stale and is dropped — see the slice.
  pagesScannedRequestedFor: null,
}
